export default class TipoTramiteComponentProp {
    constructor(public name?: string, public type?: string, public required: boolean = false, public label: string = String()) {
    }
}

